export default "__VITE_ASSET__D4AOJ1Wx__"